// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_1mGOfNl","container":"_1Aiipc5","icon":"_2n_IcVh","menu":"_3MaLOBm"};